/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmAddressTokenHoldingListRequest = {
    address?: string;
    tokenType?: EvmAddressTokenHoldingListRequest.tokenType;
    size?: number;
    page?: number;
};

export namespace EvmAddressTokenHoldingListRequest {

    export enum tokenType {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

